/**
 * Prüft, ob alle Bilder innerhalb eines Selectors fertig geladen sind
 *
 * @param {string} selector - JQuery Selektor dessen enthaltenen img-Tags geprüft werden sollen
 *
 * @return {boolean}
 */
function nc_checkImagesLoaded(selector) {
    var moduleLogger = LoggerManager.get('check-images-loaded').setPrefix(((typeof selector === 'object') ? 'Element:' + ' #' + $(selector).attr('id') : 'Selektor: ' + selector));
    moduleLogger.trace('SCRIPT START', selector);

    var imagesLoaded = true;
    if ($(selector).find('img').length) {
        moduleLogger.info($(selector).find('img').length + ' Bild(er) gefunden.');
        $(selector).find('img').each(function () {
            // Wenn das img keine src hat, oder die src keine Länge hat, oder das Bild nicht fertig geladen wurde
            if ($(this).hasClass('lazyload') || !$(this).attr('src') || !$(this).attr('src').length || !$(this).prop('complete')) {
                moduleLogger.info('Bild noch nicht fertig geladen', this);
                imagesLoaded = false;
                return false;
            }
        });
        if (imagesLoaded) {
            moduleLogger.info('Alle Bilder fertig geladen');
        }
    } else {
        moduleLogger.info('Keine Bilder gefunden');
    }
    moduleLogger.info('SCRIPT ENDE', selector);
    return imagesLoaded;
}

